export default "__VITE_ASSET__DKWzHifj__"